import { TaskFilterType } from "features/authSlice";
import { NeedStatus, NeedItem } from "pages/dashboard/home/dashboardService";
import { AdditionalDocumentationCondition } from "utilities/Constant";

/**
 * Returns a category `TaskFilterType` for a given `NeedItem` for the
 * purposes of counting tasks in the sidebar.
 * @param item 
 * @returns 
 */
export const getTaskStatusForCount = (item: NeedItem): TaskFilterType | null => {
  if (item.title.includes(AdditionalDocumentationCondition)) {
    return null;
  }
  
  if (!item.needStatus) {
    return TaskFilterType.ToDo;
  }

  switch (item.needStatus.toLowerCase()) {
    case NeedStatus.ReviewNeeded.toLowerCase():
      return TaskFilterType.UnderReview;
    case NeedStatus.Satisfied.toLowerCase():
    case NeedStatus.Completed.toLowerCase():
      return TaskFilterType.Complete;
    case NeedStatus.New.toLowerCase():
    case NeedStatus.PendingDocuments.toLowerCase():
    case NeedStatus.Unknown.toLowerCase():
    default:
      return TaskFilterType.ToDo;
  }
};

/**
 * Returns a category `TaskFilterType` for a given `PendingItem` for the
 * purposes of sorting tasks into tabs.
 * "Additional Documentation" items always reside in the ToDo tab
 * but are excluded from the sidebar count.
 */
export const getTaskStatus = (item: NeedItem): TaskFilterType =>
  getTaskStatusForCount(item) ?? TaskFilterType.ToDo;